import React, {forwardRef, useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {ModalWrapper} from './ModalWrapper';

import './react-native-components-in-react.css';
import {Button, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import ReactDOM from "react-dom";
import Styles from "../../Styles";

export const View = (props) => {
    const className = props.className ? props.className : '';

    return <div
        id={props.id}
        style={{ ...props.style }}
        className={"flex-config " + className}
        onClick={props.onPress}
    >
        {props.children}
    </div>;
};

export const Text = (props) => {
    return <View onPress={props.onPress} style={{ ...props.style }} className={props.className}>
        {props.children}
    </View>;
};

export const CCText = (props) => {
    return <Text
        style={{ ...props.style }}
        className={props.className}
        onPress={props.onPress}
    >
        {props.children}
    </Text>;
};

export const Image = (props) => {
    return <img src={props.source.uri} style={{...props.style}} className={props.className} />;
};

export const TextInput =  forwardRef((props, ref: React.ForwardedRef<any>) => {
    // @ts-ignore
    let type = props.type ? props.type : "text";

    // @ts-ignore
    if (props.keyboardType == "numeric") {
        type = "number"
    }

    return <input
        ref={ref}
        onChange={(event) => {
            // @ts-ignore
            if (props.onChange) {
                const ev = {
                    nativeEvent: {
                        text: event.target.value
                    }
                }

                // @ts-ignore
                props.onChange(ev);
            }

            // @ts-ignore
            if (props.onChangeText)
                // @ts-ignore
                props.onChangeText(event.target.value);
        }}
        // @ts-ignore
        onFocus={props.onFocus}
        // @ts-ignore
        onBlur={props.onBlur}
        type={type}
        // @ts-ignore
        value={props.value}
        // @ts-ignore
        placeholder={props.placeholder}
        // @ts-ignore
        style={{ ...props.style }}
        // @ts-ignore
        className={(props.ignoreDefaultClassNames ? "" : "chocoform-field ") + props.className}
    />;
});

export const ScrollView = (props) => {
    let scrollableStyle = {};

    if (props.style) {
        if (props.style.height > 0 || props.style.maxHeight > 0) {
            scrollableStyle = {
                overflowX: "hidden",
                overflowY: "auto",
            }
        }
    }

    return <View style={{ ...scrollableStyle, ...props.style }} className={props.className}>
        {props.children}
    </View>;
};

export const FlatList = (props) => {
    return <ScrollView style={props.style} className={props.className}>
        {props.ListHeaderComponent ? props.ListHeaderComponent() : null}
        {props.data.map(i => {
            const item = {
                item: i
            }

            return <View
                key={props.keyExtractor(item)}
                className={props.itemClassName}
            >
                {props.renderItem(item)}
            </View>
        })}
        {props.ListFooterComponent ? props.ListFooterComponent() : null}
    </ScrollView>;
};

export const TouchableWithoutFeedback = (props) => {
    const navigate = useNavigate();
    let onPress = (event) => {
        if (props.onPress)
            props.onPress(event);

        if (props.to) {
            const to = typeof props.to === "string" ? props.to : props.to.uri;
            const replace = props.to.config ? props.to.config.replace : false;
            navigate(to, { replace: replace });
        }
    }

    return <View style={props.style} className={"view-button " + props.className} onPress={onPress}>
        {props.children}
    </View>;
};

export const TouchableNativeFeedback = (props) => {
    return <TouchableWithoutFeedback {...props} />;
};

export const TouchableHighlight = (props) => {
    return <TouchableWithoutFeedback {...props} />;
};

export const TouchableOpacity = (props) => {
    return <TouchableWithoutFeedback {...props} />;
};

export const ActivityIndicator = ({ style = {}, size = 40, color = '#f05423', borderWidth = 4 }) => {
    const spinnerStyle = {
        width: `${size}px`,
        height: `${size}px`,
        borderTop: `${borderWidth}px solid ${color}`,
        borderRight: `${borderWidth}px solid transparent`,
    };

    return <View style={{ justifyContent: 'center', alignItems: 'center', ...style }}>
        <div className="loading-spinner" style={spinnerStyle}></div>
    </View>;
};

export const Modal = (props) => {
    const [modalNumber] = useState(Math.floor(Math.random() * 1000001))
    const navigate = useNavigate();

    useEffect(() => {
        if (props.visible) {
            navigate(window.location.pathname + window.location.search + '#' + modalNumber);
        } else if(window.location.href.includes('#' + modalNumber)) {
            navigate(-1);
        }


        const unlisten = () => {
            if (props.visible && !window.location.href.includes('#' + modalNumber)) {
                props.onRequestClose();
            }
        };

        window.addEventListener("popstate", unlisten);

        return () => {
            window.removeEventListener("popstate", unlisten);
        };
    }, [props.visible]);

    return <ModalWrapper
        visible={props.visible}
        onRequestClose={props.onRequestClose}
        hideHeader={props.hideHeader}
        style={props.style}
        bodyStyle={props.bodyStyle}
        footer={props.footer}
    >
        {props.children}
    </ModalWrapper>;
};
const CustomAlert = ({ title, message, buttons, onHide }) => {
    const handleButtonClick = (button) => {
        if (button && button.onPress) {
            button.onPress();
        }
        onHide();
    };

    const buttonStyle = (button) => {
        const { style, backgroundColor, borderRadius } = button;
        return {
            backgroundColor,
            borderRadius,
            ...(style === 'cancel' ? { marginRight: '10px' } : {}),
        };
    };

    return (
        <Modal isOpen={true} toggle={onHide}>
            <ModalHeader toggle={onHide}>{title}</ModalHeader>
            <ModalBody>{message}</ModalBody>
            <ModalFooter>
                {(buttons && buttons.length > 0
                        ? buttons
                        : [
                            {
                                text: 'Close',
                                onPress: null,
                                style: 'secondary',
                            },
                        ]
                ).map((button, index) => (
                    <Button
                        key={index}
                        color={button.style || 'secondary'}
                        onClick={() => handleButtonClick(button)}
                        style={buttonStyle(button)}
                    >
                        {button.text}
                    </Button>
                ))}
            </ModalFooter>
        </Modal>
    );
};

class AlertManager {
    alertRoot;

    constructor() {
        this.alertRoot = document.createElement('div');
        const appRoot = document.getElementById('root') || document.getElementById('app');
        // @ts-ignore
        appRoot.appendChild(this.alertRoot);
        this.handleBackButton = this.handleBackButton.bind(this);
    }

    alert(title, message, buttons) {
        const hideAlert = () => {
            ReactDOM.unmountComponentAtNode(this.alertRoot);
            window.removeEventListener('popstate', this.handleBackButton);
        };

        const alertComponent = (
            <CustomAlert title={title} message={message} buttons={buttons} onHide={hideAlert} />
        );

        ReactDOM.render(alertComponent, this.alertRoot);
        window.addEventListener('popstate', this.handleBackButton);
    }

    handleBackButton(e) {
        e.preventDefault();
        this.alertRoot.childNodes[0].childNodes[0].click(); // Simulate the close button click
    }
}

const alertManagerInstance = new AlertManager();
const alertFunction = alertManagerInstance.alert.bind(alertManagerInstance);

export const Alert = {
    alert: alertFunction
};

export const AlertModal = (props) => {

    return <ModalWrapper
        visible={props.visible}
        onRequestClose={props.onRequestClose}
        hideHeader={true}
        windowMode={true}
    >
        {props.title ?
            <Text style={{ fontWeight: 'bold', fontSize: 20, ...Styles.themeColor }}>
                {props.title}
            </Text>
            :
            null
        }
        {props.text ?
            <Text style={{ marginTop: 15 }}>
                {props.text}
            </Text>
            :
            null
        }
        {props.buttons.length > 0 ?
            <View style={{ flexDirection: 'row', justifyContent: 'flex-end', marginTop: 15 }}>
                {props.buttons.map(item => {
                    const containerStyles = {};
                    const textStyles = {};

                    switch (item.type) {
                        case 'danger':
                            // @ts-ignore
                            textStyles.color = Styles.redColor.color;

                            // @ts-ignore
                            containerStyles.padding = '5px 10px';
                            break;
                        case 'dark':
                            // @ts-ignore
                            textStyles.color = 'white';

                            // @ts-ignore
                            containerStyles.backgroundColor = Styles.textColor.color;
                            // @ts-ignore
                            containerStyles.padding = '5px 10px';
                            // @ts-ignore
                            containerStyles.borderRadius = 6;
                            break;
                        default:
                            // @ts-ignore
                            containerStyles.padding = '5px 10px';
                            break;
                    }

                    return <TouchableOpacity
                        key={item.text}
                        onPress={() => {
                            item.onPress();
                            props.onRequestClose();
                        }}
                        style={{ marginLeft: 15, ...containerStyles }}
                    >
                        <Text
                            style={{ ...textStyles }}
                        >
                            {item.text}
                        </Text>
                    </TouchableOpacity>;
                })}
            </View>
            :
            null
        }
    </ModalWrapper>;
};